import { Flex, Text, BoxProps } from "@chakra-ui/react";
import { AddedBubbleIcon } from "../../icons/AddedBubbleIcon";
import { t } from "i18next";

interface PDFBadgeProps extends BoxProps {
  fontSize?: string;
  letterSpacing?: string;
}

export function PDFBadge({ fontSize, letterSpacing, ...props }: PDFBadgeProps) {
  return (
    <Flex
      gap="5px"
      alignItems="center"
      background="charcoal.900"
      borderRadius="4px"
      p="4px 8px"
      color="success.300"
      width="fit-content"
      {...props}
    >
      <AddedBubbleIcon boxSize="10px" />
      <Text as="span" fontSize="12px" fontWeight="bold">
        {t("components.cards.unlockReleaseCard.pdf")}
      </Text>
    </Flex>
  );
}
